import React, { useEffect, useState } from 'react';
import { PagingQuery, Button } from 'tea-component';
import Filter from '@/pages/intelligence/pages/TopCharts/Companies/components/GamesDetails/GamesStats/components/Sizer/PhysicalRevenueDetailFilter';
import { useIntl, connect } from 'umi';
import { FILTER_EXTEND_NAMESPACE } from '@/pages/intelligence/models/filterExtend';
import { DBI_TOPCHARTS } from '@/pages/intelligence/models/topcharts';
import { updateDefaultTimeParams } from '@/pages/intelligence/pages/TopCharts/_config/detailDefaltfilterTime';
import TrendsCard from './TrendsCard';
import GamesCard from './GamesCard';
import { getPhysicalRevenueGamesData, getPhysicalRevenueTrendData } from './_utils';
import { useCompanyOptionList } from '@/pages/intelligence/pages/TopCharts/_hooks/useCompanyOptionList';
import { SortByItemType } from '@/pages/intelligence/components/TableComponents/components/SortBy';
import * as filterKeyMap from '@/pages/intelligence/components/Filter/FilterBase/_config';
import useFilterExtend from '@/pages/intelligence/hooks/useFilterExtend';
import DetailDownload from '@/pages/intelligence/pages/TopCharts/Companies/components/GamesDetails/GamesStats/components/DetailDownload';
import { getDeviceConfig } from '@/pages/intelligence/pages/TopCharts/PCGames/_config/utils';
import { COMBINEID_REG } from '@intelligence/utils/constant';

const GamesStatsPhysicalRevenue = (props: any) => {
  const {
    tabId,
    filterState,
    companyId,
    entityType,
    gameName,
    setMainLoading,
    mainLoading,
    setDownloadParamsNormal,
    downloadParamsNormal,
  } = props;
  const { formatMessage } = useIntl(); // 中英切换方法

  const deviceDefVales = getDeviceConfig('PhysicalRevenue', entityType)?.value;
  const deviceOptions = getDeviceConfig('PhysicalRevenue', entityType)?.options;

  const { isOperateDetail, detailFilterExtend } = useFilterExtend({});
  const [trendLineList, setTrendLineList] = useState<any>([]);
  const [trendTableList, setTrendTableList] = useState<any>([]);
  const [trendCardStats, setTrendCardStats] = useState<any>({
    isLoading: true,
    isError: false,
    isNoData: true,
  });
  //   trend标题加上数据聚合方式
  const [trendComputeType, setTrendComputeType] = useState('');
  const [trendCount, setTrendCount] = useState('');

  const [gameChartLoading, setGameChartLoading] = useState(true);
  const [gameChartType, setGameChartType] = useState<string>('pie');

  const [gameTableLoading, setGameTableLoading] = useState(false);
  const [countriesChartLoading, setCountriesChartLoading] = useState(true);
  const [countriesChartType, setCountriesChartType] = useState<string>('pie');
  const [gameTotal, setGameTotal] = useState<number>(0);
  const [gameTableList, setGameTableList] = useState<any>([]);
  const [gameLineList, setGameLineList] = useState<any>([]);
  const [gameBarOrPieList, setGameBarOrPieList] = useState<any>([]);
  const [gameCardStats, setGameCardStats] = useState<any>({
    isLoading: true,
    isError: false,
    isNoData: true,
  });
  const { physicalTrendList, physicalGameList } = useCompanyOptionList();

  const [fetchParams, setFetchParams] = useState({
    company_id: companyId,
    entity_type: entityType,
    data_sources: ['npd'],
    order_metric: 'date',
    order: 'desc',
    page: 1,
    page_size: 5,
    region_type: 'market',
    regions: ['us'],
    period: 'month',
    start_date: '',
    end_date: '',
    metrics: ['revenue'],
  });

  useEffect(() => {
    if (companyId) {
      let newFetchParams = {
        ...fetchParams,
      };
      if (isOperateDetail === true) {
        /** 获取继承参数 */
        const extendParams = getExtendParams();
        newFetchParams = { ...newFetchParams, ...extendParams };
      }
      setFetchParams(newFetchParams);
      getPageData(newFetchParams);
    }
  }, [companyId]);

  const getExtendParams = () => {
    const newFetchParams: any = {};
    const timeExtend = detailFilterExtend[filterKeyMap.RANGE_TIME];
    if (timeExtend?.granularity === 'monthly') {
      // newFetchParams.period = timeExtend?.granularity;
      newFetchParams.start_date = timeExtend?.start_date || '';
      newFetchParams.end_date = timeExtend?.end_date || '';
    }
    return newFetchParams;
  };

  const getPageData = (params) => {
    // 返回状态， 折线， 表格，
    // 当筛选器更改时，使用新的筛选条件重新渲染卡片
    // 添加ID校验规则
    if (COMBINEID_REG.test(companyId)) {
      getTrendCardData(params, tabId);
      getGamesCardData(params);
    }
  };

  const getGamesCardData = async (params) => {
    setGameCardStats({
      ...gameCardStats,
      isLoading: true,
    });
    const gameData = await getPhysicalRevenueGamesData(params, tabId);
    const { cardStats, lineData, barOrPieData, tableData, total } = gameData;
    setGameCardStats(cardStats);
    setGameLineList(lineData);
    setGameBarOrPieList(barOrPieData);
    setGameTableList(tableData);
    setGameTotal(total);
  };

  const getTrendCardData = async (params) => {
    setTrendCardStats({
      ...trendCardStats,
      isLoading: true,
    });
    setMainLoading(true);
    setDownloadParamsNormal(params);
    const gameData = await getPhysicalRevenueTrendData(params, tabId);
    const { startDate, endDate, cardStats, lineData, tableData, total, trendCoundMsg } = gameData;
    setDownloadParamsNormal({
      ...params,
      start_date: startDate,
      end_date: endDate,
    });
    setTrendComputeType(trendCoundMsg?.type || '');
    setTrendCount(trendCoundMsg?.value || 0);

    setTrendCardStats(cardStats);
    setTrendLineList(lineData || []);
    setTrendTableList(tableData || []);
    const updatedFetchParams: any = updateDefaultTimeParams({
      fetchParams: params,
      startDate,
      endDate,
      period: params.period,
      isTwoMonths: false,
    });
    setFetchParams(updatedFetchParams);
    setMainLoading(false);
  };

  const handleConfirm = (value: any) => {
    const newFetchParams = { ...fetchParams, ...value };
    getPageData(newFetchParams);
  };

  const onGameTableSortChage = async (e: SortByItemType) => {
    const newFetchParams = {
      ...fetchParams,
      order: e?.sortVal,
      order_metric: e?.ratioType === 1 ? `${e?.sortMetric}_ratio` : e?.sortMetric,
    };
    setGameTableList([]);
    setGameTableLoading(true);
    const gameData = await getPhysicalRevenueGamesData(newFetchParams, tabId);
    const { tableData } = gameData;
    setGameTableList(tableData);
    setGameTableLoading(false);
  };

  const onGameTablePagingChange = async (e: PagingQuery) => {
    const newFetchParams = {
      ...fetchParams,
      page: e?.pageIndex || 1,
      page_size: e?.pageSize || 5,
    };
    setGameTableList([]);
    setGameTableLoading(true);
    const gameData = await getPhysicalRevenueGamesData(newFetchParams, tabId);
    const { tableData } = gameData;
    setGameTableList(tableData);
    setGameTableLoading(false);
  };

  return (
    <>
      <div className="dbi-statsfilter-warp">
        <div className="statsfilter-warp-left">
          <Filter
            timeFilterValues={{
              type: fetchParams.period,
              value: [fetchParams.start_date, fetchParams.end_date],
            }}
            buttonLogConfig={{}}
            filterConfirm={handleConfirm}
            filterReset={() => {}}
            filterInit={() => {}}
            deviceDefVales={deviceDefVales}
            deviceOptions={deviceOptions}
          />
          <span className="dbi-statsfilter-warp-left-text">{formatMessage({ id: 'dbi_us_only' })}</span>
        </div>
        <div className="dbi-statsfilter-warp-right">
          <DetailDownload
            entityType={entityType}
            mainLoading={mainLoading}
            downloadParamsNormal={downloadParamsNormal}
            gameName={gameName}
            segpaVa={entityType}
            segment={'physicalRevenue'}
          />
        </div>
      </div>
      <TrendsCard
        lineData={trendLineList}
        tableData={trendTableList}
        dateType={fetchParams?.period}
        cardStatus={trendCardStats}
        trendComputeType={trendComputeType}
        trendCountValue={trendCount}
        columnsList={physicalTrendList}
        entityType={entityType}
        setChartLoading={setGameChartLoading}
        chartLoading={gameChartLoading}
        tabId={tabId}
        chartType={gameChartType}
        setChartType={setGameChartType}
      />
      <GamesCard
        lineData={gameLineList}
        tableData={gameTableList}
        barOrPieList={gameBarOrPieList}
        dateType={fetchParams?.period}
        startDate={fetchParams?.start_date}
        endDate={fetchParams?.end_date}
        cardStatus={gameCardStats}
        tableTotal={gameTotal}
        columnsList={physicalGameList}
        tableLoading={gameTableLoading}
        onTableSortChage={onGameTableSortChage}
        onTablePagingChange={onGameTablePagingChange}
        entityType={entityType}
        setChartLoading={setCountriesChartLoading}
        chartLoading={countriesChartLoading}
        tabId={tabId}
        chartType={countriesChartType}
        setChartType={setCountriesChartType}
        gameName={gameName}
      />
    </>
  );
};
export default connect((state: any) => {
  return {
    filterState: state[FILTER_EXTEND_NAMESPACE],
    topchartsState: state[DBI_TOPCHARTS],
  };
})(GamesStatsPhysicalRevenue);
